<template>
  <!-- 整箱存放专用列表：箱子行展开后展示箱内商品 -->
  <div class="warehouse-box-list" >
    <!-- 整箱列表表头 -->
    <div class="box-grid box-header">
      <div><el-checkbox v-model="allChecked" @change="toggleAll" /></div>
      <div>NO</div>
      <div>箱号</div>
      <div>箱内SKU数</div>
      <div>箱内商品数</div>
      <div>实际重量(kg)</div>
      <div>箱子尺寸(cm)</div>
      <div>入库时间</div>
      <div>库龄(已保管天数)</div>
      <div>箱内商品价值(元)</div>
      <div>已产生仓储费(元)</div>
      <div>待支付仓储费(元)</div>
    </div>
    <!-- 箱子按订单分组并支持展开收起 -->
    <article
      v-for="(box, index) in boxes"
      :key="box.id || box.order_box_id || index"
      class="box-group"
    >
      <div class="box-grid box-row">
        <!-- 复选框独占第一列，此处不展示箱子ID -->
        <div>
          <el-checkbox-group v-model="selectedKeys" @change="syncAllChecked">
            <el-checkbox class="box-checkbox" :label="key(box, index)" />
          </el-checkbox-group>
          <!-- 展开收起按钮固定在箱体编号下方 -->
          <el-button class="box-toggle" size="mini" @click="toggle(box, index)">
            {{ isExpanded(box, index) ? "收起" : "展开" }}
          </el-button>
        </div>
        <!-- 箱号下方显示箱子 ID -->
        <!-- NO列展示当前列表序号 -->
        <div>{{ box.rowNumber }}</div>
        <!-- 箱号列保留来源单号和箱号的拼接内容 -->
        <div class="box-number-cell">
          BOX-{{ box.order_sn }}-{{ box.box_no }}
        </div>
        <div>{{ box.sku_count }}</div>
        <div>{{ box.total_num }}</div>
        <div>{{ box.weight }}</div>
        <div>{{ box.attr }}</div>
        <div>{{ box.inbound_at }}</div>
        <div>{{ box.storage_days }}</div>
        <div>{{ box.goods_value }}</div>
        <div>{{ box.settled_storage_fee }}</div>
        <div>{{ box.unsettled_storage_fee }}</div>
      </div>
      <!-- 展开后展示箱内商品明细 -->
      <div v-if="isExpanded(box, index)" class="box-products">
        <div class="product-grid product-header">
          <div>订单号/番号</div>
          <div>番号</div>
          <div>商品属性</div>
          <div>图片</div>
          <div>数量</div>
        </div>
        <div
          v-for="(item, itemIndex) in box.order_detail_list || []"
          :key="item.id || itemIndex"
          class="product-grid product-row"
        >
          <!-- 订单号点击后新窗口打开订单详情 -->
          <router-link
            v-if="item.order_sn"
            class="box-order-link"
            :to="'/orderPaymentDetail?order_sn=' + item.order_sn"
            target="_blank"
          >
            {{ item.order_sn }}
          </router-link>
          <span v-else>-</span>
          <div>{{ item.sorting }}</div>
          <div class="product-attributes">
            <p v-for="(attribute, attributeIndex) in item.detail_y" :key="attributeIndex">
              {{ attribute.key }}：{{ attribute.value }}
            </p>
          </div>
          <div>
            <!-- 使用Element图片预览，点击明细缩略图后查看大图 -->
            <el-image
              class="product-image"
              :src="item.pic"
              :preview-src-list="item.pic ? [item.pic] : []"
              fit="cover"
            />
          </div>
          <div>{{ item.num }}</div>
        </div>
      </div>
    </article>
    <!-- 无数据提示 -->
    <div v-if="!loading && !boxes.length" class="empty-list">暂无数据</div>
    <!-- 整箱列表底部批量操作栏 -->
    <div v-if="boxes.length" class="box-bottom-bar">
      <el-checkbox v-model="allChecked" @change="toggleAll">全选</el-checkbox>
      <span>已选：{{ selectedKeys.length }} 件</span>
      <!-- 底部右侧操作与普通仓库列表保持一致 -->
      <div class="box-bottom-actions">
      
        <el-button type="primary" :disabled="!selectedKeys.length" @click="openSubmitConfirm">
          提出配送单
        </el-button>
      </div>
    </div>
    <!-- 生成配送单前二次确认已选箱子 -->
    <el-dialog
      title="生成配送单确认"
      :visible.sync="submitConfirmVisible"
      width="520px"
      append-to-body
    >
      <!-- 展示已选箱子的订单号和拼接箱号 -->
      <div class="submit-confirm-list">
        <div
          v-for="(box, index) in selectedBoxes"
          :key="'submit-box-' + key(box, index)"
          class="submit-confirm-item"
        >
          <span class="submit-confirm-index">{{ index + 1 }}</span>
       
          <span>箱号：{{ box.order_sn || '-' }}-{{ box.box_no }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitConfirmVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSubmit">确认生成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // 整箱存放独立列表组件
  name: "WarehouseBoxList",
  props: {
    boxes: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      // 记录每个箱子行的展开状态
      expanded: {},
      // 保存复选框组当前选中的箱子键值
      selectedKeys: [],
    
      // 表头与底部全选复选框的同步状态
      allChecked: false,
      // 控制提交已选箱子前的二次确认弹框
      submitConfirmVisible: false,
    };
  },
  computed: {
    // 根据选中键值取得原始箱子数据并在确认弹框中展示
    selectedBoxes() {
      return this.boxes.filter((box, index) => this.selectedKeys.includes(this.key(box, index)));
    },
  },
 
  methods: {
    // 使用箱子 ID 记录展开状态
    key(box, index) {
      return box.id || box.order_box_id || index;
    },
    isExpanded(box, index) {
      return !!this.expanded[this.key(box, index)];
    },
    toggle(box, index) {
      const key = this.key(box, index);
      this.$set(this.expanded, key, !this.expanded[key]);
    },
    // 切换单个箱子的勾选状态
    isSelected(box, index) {
      return this.selectedKeys.includes(this.key(box, index));
    },
    toggleSelected(box, index, checked) {
      const key = this.key(box, index);
      this.selectedKeys = checked
        ? this.selectedKeys.concat(key)
        : this.selectedKeys.filter((item) => item !== key);
    },
    // 单个箱子变更后同步全选状态
    syncAllChecked() {
      this.allChecked = this.boxes.length > 0 && this.selectedKeys.length === this.boxes.length;
    },
    // 切换全部箱子的勾选状态
    toggleAll(checked) {
      this.selectedKeys = checked
        ? this.boxes.map((box, index) => this.key(box, index))
        : [];
    },
    // 至少选中一个箱子时打开二次确认弹框
    openSubmitConfirm() {
      if (this.selectedKeys.length) {
        this.submitConfirmVisible = true;
      }
    },
    // 将确认后的箱子ID传给父页面提交接口
    confirmSubmit() {
      this.submitConfirmVisible = false;
      this.$emit('submit', this.selectedKeys.slice());
    },
  },
};
</script>

<style lang="scss" scoped>
// 整箱列表宽度和普通仓库保持一致
.warehouse-box-list {
  width: 100%;
  min-width: 0;
  // 不创建嵌套滚动容器，使粘性表头和底部栏跟随页面滚动
  overflow: visible;
  color: #333;
}
// 箱子主表格布局
.box-grid {
  display: grid;
  // 缩窄复选框和NO列，为拼接箱号预留更多宽度
  grid-template-columns: 4% 5% 18% repeat(9, minmax(0, 1fr));
  width: 100%;
  min-width: 0;
}
.box-header {
  // 列表滚动时保持整箱表头可见
  position: sticky;
  top: 0;
  z-index: 5;
  min-height: 48px;
  align-items: center;
  background: #eef0f5;
  border: 1px solid #e4e7ed;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
.box-row {
  position: relative;
  min-height: 90px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  font-size: 14px;
}
// 箱子分组作为展开按钮的定位父元素
.box-group {
  position: relative;
}
.box-row > div {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 6px;
  box-sizing: border-box;
  text-align: center;
}
.box-row > div:first-child { flex-direction: column; gap: 8px; }
// 隐藏Element复选框的label文字，同时保留label作为选中值
.box-checkbox /deep/ .el-checkbox__label { display: none; }
.box-number-cell { flex-direction: column; gap: 4px; }
.box-id { color: #606266; font-size: 14px; }
.box-order-link { color: #c7252b; text-decoration: underline; }
// 箱内商品展开区域
.box-products {
  border-top: 1px solid #ebeef5;
}
.product-grid {
  display: grid;
  grid-template-columns: 24% 12% 32% 20% 12%;
  width: 100%;
}
.product-header {
  min-height: 56px;
  align-items: center;
  background: #dfe3eb;
  color: #666;
  font-size: 14px;
  text-align: center;
}
.product-row {
  min-height: 70px;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
}
.product-attributes { text-align: left; }
.product-attributes p { margin: 0; line-height: 1.45; }
.product-image {
  width: 60px;
  height: 60px;
  background: #dcdcdc;
  border-radius: 4px;
}
.box-toggle {
  height: 20px;
  margin: 0;
  padding: 1px 6px;
  font-size: 11px;
}
.empty-list {
  padding: 70px 20px;
  color: #909399;
  text-align: center;
}
.box-bottom-bar {
  position: sticky;
  bottom: 0;
  z-index: 5;
  display: flex;
  gap: 18px;
  align-items: center;
  min-height: 54px;
  padding: 0 16px;
  box-sizing: border-box;
  background: #fff;
  border-top: 1px solid #ebeef5;
}
.box-bottom-actions {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-left: auto;
}

// 原生复选框保持与仓库列表复选框尺寸一致
</style>
